import ActionTypes from "../constants/ActionTypes";

const initialState = {
  loading: false,
  userdata: {},
  error: null
};
const userListReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.USER_EDIT_REQUEST:
      return { ...state, loading: true };
    case ActionTypes.USER_EDIT_SUCCESS:
      return { ...state, loading: false, userdata: action.payload };
    case ActionTypes.USER_EDIT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case ActionTypes.USER_UPDATE_REQUEST:
      return { ...state, loading: true };
    case ActionTypes.USER_UPDATE_SUCCESS:
      return { ...state, loading: false};
    case ActionTypes.USER_UPDATE_FAILURE:
      return { ...state, loading: false};
    default:
      return state;
  }
};

export default userListReducer;
